import React from "react";
import { TabbedShowLayout, Tab, ShowProps } from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import Financial from "./Financial";
import Student from "./Student";
import { Grid } from "@material-ui/core";
import { GetParam } from "utils/tools";
import ShowWrapper from "../../components/ShowWrapper";

const PersonInChargeShow = (props: ShowProps) => {
  const param = GetParam();
  const { id } = props;

  let breadcrumbValue = [{ link: "", title: "" }];

  if (param.get("companyId")) {
    breadcrumbValue = [
      {
        title: "Companies",
        link: `/companies/${param.get("companyId")}/show`,
      },
      {
        title: "Person In Charges",
        link: `/companies/${param.get("companyId")}/show/2`,
      },
      {
        title: id,
        link: "",
      },
    ];
  } else {
    breadcrumbValue = [
      { link: "/personInCharges", title: "Person In Charges" },
      {
        title: id,
        link: "",
      },
    ];
  }

  const breadcrumb = breadcrumbValue;

  return (
    <>
      <ShowWrapper breadcrumb={breadcrumb} isFullName actions={null} {...props}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Financial">
                <Financial {...props} />
              </Tab>
              <Tab label="Student">
                <Student {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default PersonInChargeShow;
